import {SettingsHeader} from "./Utils/SettingsHeader";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import React from "react";
import SwitchYesNoBox from "./Utils/SwitchYesNoBox";
import {useStores} from "../../../../Hooks";
import {observer} from "mobx-react";
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import GlobalUtility from "../../../../Utilities/GlobalUtility";

export const SubWorkspacePermissions = observer(({showHeader}) => {
    const {generalStore, workspaceManagementStore} = useStores();

    const onChangeSetting = (settingName) =>{
        workspaceManagementStore.editedDomain = {
            ...workspaceManagementStore.editedDomain,
            [settingName]: !workspaceManagementStore.editedDomain[settingName],
        };
    }
    const permissions = [
        {
            title: 'Can create sub-workspaces',
            value: workspaceManagementStore.editedDomain.CanCreateCustomers,
            onChange: () => {

                let newPermissions ={}
                if (workspaceManagementStore.editedDomain.CanCreateCustomers){
                    newPermissions = {
                        CanDeleteSubWorkspace: false,
                        CanCallSubDomainUsers: false,
                        CanMirrorParentProjects: false,
                        CanEditExpirationDate: false
                    }
                    workspaceManagementStore.disabledPermissions = true
                } else{
                    workspaceManagementStore.disabledPermissions = false
                }
                workspaceManagementStore.editedDomain = {
                    ...workspaceManagementStore.editedDomain,
                    CanCreateCustomers: !workspaceManagementStore.editedDomain.CanCreateCustomers,
                    Channel: !workspaceManagementStore.editedDomain.CanCreateCustomers,
                    ...newPermissions,
                };

            },
            disabled: false

        },
        {
            title: `Can call it's sub-workspaces members via remote support`,
            value: workspaceManagementStore.editedDomain.CanCallSubDomainUsers,
            onChange: () => {
                onChangeSetting('CanCallSubDomainUsers')
            },
            disabled: workspaceManagementStore.disabledPermissions

        },
        {
            title: `Can delete it's sub-workspaces`,
            value: workspaceManagementStore.editedDomain.CanDeleteSubWorkspace,
            onChange: () => {
                onChangeSetting('CanDeleteSubWorkspace')
            },
            disabled: workspaceManagementStore.disabledPermissions
        },
        {
            title: `Can mirror it's projects in to sub-workspaces`,
            value: workspaceManagementStore.editedDomain.CanMirrorParentProjects,
            onChange: () => {
                onChangeSetting('CanMirrorParentProjects')
            },
            disabled: workspaceManagementStore.disabledPermissions

        },
        {
            title: `Can edit expiration date of it's sub-workspaces`,
            value: workspaceManagementStore.editedDomain.CanEditExpirationDate,
            onChange: () => {
                onChangeSetting('CanEditExpirationDate')
            },
            disabled: workspaceManagementStore.disabledPermissions

        },
        {
            title: `Can add AI chat knowledge`,
            value: workspaceManagementStore.editedDomain.CanAddAiChatKnowledge,
            onChange: () => {
                onChangeSetting('CanAddAiChatKnowledge')
            },
            disabled: !GlobalUtility.isFlagOn(generalStore, 'CanAddAiChatKnowledge'),
            tooltiplabel:  !GlobalUtility.isFlagOn(generalStore, 'CanAddAiChatKnowledge') ? "This sub-workspace cannot add AI chat knowledge." : workspaceManagementStore.editedDomain.CanAddAiChatKnowledge ? "This sub-workspace can add its own AI chat knowledge." : "This sub-workspace only uses parent/global knowledge."

        }

    ]


    return (
        <section className="flex-grow flex-col bg-inputfield-normal rounded-menu p-2 font-sans">
            <ConditionalComponent if={showHeader}>
                <SettingsHeader title={'Workspace Permissions'} Icon={LockOutlinedIcon}/>
            </ConditionalComponent>
            {permissions.map(permission => (
                <div key={permission.title}>
                    <div className="flex flex-row justify-between p-1 text-xs items-center">
                        <div>{permission.title}</div>
                        <SwitchYesNoBox checked={permission.value} setChecked={permission.onChange} disabled={permission.disabled} tooltiplabel={permission.tooltiplabel} data-testid={`sub-ws-permission-${permission.title.replace(/\s+/g, '-').toLowerCase()}`}/>
                    </div>
                </div>
            ))}
        </section>
    );
});